import { Component } from '@angular/core';

@Component({
    selector: 'app-post-skeleton',
    standalone: false,
    templateUrl: './post-skeleton.component.html',
    styleUrl: './post-skeleton.component.scss',
})
export class PostSkeletonComponent {}
